import { ProgressConfigT } from '@/store/slices/progressSlice';
import { path } from '@/routes/Routes.helpers';
import { AI_TASK_TYPES, AiTaskTypeT } from '@/api/aiApi/types';

export const UPLOADING_FILES_AI_TASKS: AiTaskTypeT[] = [
    AI_TASK_TYPES.RemoveBg,
    AI_TASK_TYPES.ClothingAttributes,
];

export const UPLOADING_FILES_CONFIG: Partial<ProgressConfigT> = {
    Completed: {
        label: 'Все изделия готовы',
        button: {
            text: 'В гардероб',
            link: path('wardrobeAdd'),
        },
    },
};
